import Header from '@components/Header';
import colors from '@constants/colors';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import SettingIcon from '@icons/setting/SettingLine';

import MyMenuBottomSheet from './MyMenuSettingBottomSheet';

function MyMenuHeader() {
  const { openBottomSheet } = useBottomSheet();
  const handleSettingClick = () => {
    openBottomSheet('MY메뉴 설정', <MyMenuBottomSheet/>);
  };
  return (
        <Header title='MY메뉴 전체보기'
                trailing={<SettingIcon size={30}
                                       onClick={handleSettingClick}
                                       color={colors.gray9} />} />
  );
}

export default MyMenuHeader;
